import type { Measure } from './api/client';

export const isSim = (m: { source?: string } | undefined) => m?.source === 'simulated';

/** A Measure as display text, or an em dash when there is nothing to measure. */
export function num(m: Measure | undefined, digits = 0, scale = 1): string {
  if (m?.value == null) return '—';
  return (m.value * scale).toFixed(digits);
}

export function ago(iso: string | undefined, now: number): string {
  if (!iso) return 'never';
  const s = Math.max(0, Math.round((now - Date.parse(iso)) / 1000));
  if (s < 90) return `${s} s`;
  const m = Math.round(s / 60);
  return m < 90 ? `${m} min` : `${Math.round(m / 60)} h`;
}

export function hhmm(iso: string, timezone?: string): string {
  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: timezone }).format(new Date(iso));
}

export function hhmmss(iso: string, timezone?: string): string {
  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23', timeZone: timezone }).format(new Date(iso));
}

export function dateShort(iso: string): string {
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(iso));
}

export const healthLabel: Record<string, string> = { healthy: 'Healthy', degraded: 'Degraded', offline: 'Offline' };

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
}

/** Time left until `iso`, e.g. "19 h" or "25 min"; "now" once passed. */
export function until(iso: string, now: number): string {
  const s = Math.round((Date.parse(iso) - now) / 1000);
  if (s <= 0) return 'now';
  const m = Math.round(s / 60);
  return m < 90 ? `${Math.max(1, m)} min` : `${Math.round(m / 60)} h`;
}
